import { api } from '@/services/axios'

export interface GetProfileBody {
  email: string
}

export interface GetProfileResponse {
  id: number
  nome: string
  whatsapp: string
  email: string
  role: string
  permissions: number[]
}

export async function getProfile({
  email,
}: GetProfileBody): Promise<GetProfileResponse> {
  const decodedEmail = email.replace('%40', '@')

  const response = await api.post<GetProfileResponse>(`Usuario/Me`, {
    email: decodedEmail,
  })

  return response.data
}
